import { render, staticRenderFns } from "./BalanceWarning.vue?vue&type=template&id=758dcf56&"
import script from "./BalanceWarning.vue?vue&type=script&lang=js&"
export * from "./BalanceWarning.vue?vue&type=script&lang=js&"
import style0 from "./BalanceWarning.vue?vue&type=style&index=0&id=758dcf56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports